import { gql } from '@apollo/client';

export const VIDEO_ATTENDEE_ATTRIBUTES = gql`
  fragment VIDEO_ATTENDEE_ATTRIBUTES on VideoAttendee {
    firstName
    lastName
    roleLabel
    attendeeId
    meetingId
    attendeeStatus
    attendeeMeetingStatus
    chimeAttendeeId
    chimeMeetingId
  }
`;

export const SESSION_VIDEO_MEETING_PARTICIPANTS = gql`
  ${VIDEO_ATTENDEE_ATTRIBUTES}
  query SESSION_VIDEO_MEETING_PARTICIPANTS($meetingId: ID!, $attendeeId: ID) {
    videoMeetingParticipantsWithFilters(meetingId: $meetingId, attendeeId: $attendeeId) {
      attendees {
        ...VIDEO_ATTENDEE_ATTRIBUTES
      }
      token
    }
  }
`;
